(function () {
  'use strict';

  var moneyFormat = window.themeMoneyFormat || '${{amount}}';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(cents, moneyFormat);
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function initStickyHeader() {
    var header = document.querySelector('[data-site-header]');
    if (!header) return;
    function update() {
      var y = window.scrollY || 0;
      header.classList.toggle('is-scrolled', y > 16);
      header.classList.remove('is-hidden');
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initReveal() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length || reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item) { observer.observe(item); });
  }

  function initPremiumProduct() {
    var root = document.querySelector('[data-premium-product]');
    if (!root) return;
    var form = root.querySelector('[data-product-form]');
    var dataNode = root.querySelector('[data-product-json]');
    if (!form || !dataNode) return;
    var product = JSON.parse(dataNode.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var addButton = form.querySelector('[name="add"]');
    var addText = addButton && addButton.querySelector('[data-add-text]');
    var price = root.querySelector('[data-current-price]');
    var compare = root.querySelector('[data-compare-price]');
    var saving = root.querySelector('[data-saving]');
    var selectedLabels = root.querySelectorAll('[data-selected-value]');
    var optionInputs = root.querySelectorAll('[data-option-input]');

    function selectedOptions() {
      var values = [];
      var groups = root.querySelectorAll('[data-option-group]');
      groups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        values.push(checked ? checked.value : (select ? select.value : ''));
      });
      return values;
    }

    function findVariant() {
      var values = selectedOptions();
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === values[index]; });
      });
    }

    function updateAvailability() {
      var values = selectedOptions();
      optionInputs.forEach(function (input) {
        var index = Number(input.getAttribute('data-option-index'));
        var possible = product.variants.some(function (variant) {
          if (!variant.available || variant.options[index] !== input.value) return false;
          return variant.options.every(function (optionValue, optionIndex) {
            if (optionIndex === index) return true;
            return !values[optionIndex] || optionValue === values[optionIndex];
          });
        });
        input.disabled = !possible;
        input.setAttribute('aria-disabled', possible ? 'false' : 'true');
      });
    }

    function activateMedia(mediaId) {
      if (!mediaId) return;
      var mediaItems = root.querySelectorAll('[data-media-id]');
      var thumbs = root.querySelectorAll('[data-media-thumb]');
      mediaItems.forEach(function (item) { item.classList.toggle('is-active', item.getAttribute('data-media-id') === String(mediaId)); });
      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-media-target') === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function update() {
      var variant = findVariant();
      var groups = root.querySelectorAll('[data-option-group]');
      groups.forEach(function (group, index) {
        var label = selectedLabels[index];
        var checked = group.querySelector('input:checked');
        var select = group.querySelector('select');
        if (label) label.textContent = checked ? checked.value : (select ? select.value : '');
      });
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = root.getAttribute('data-unavailable-label');
        return;
      }
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
        compare.hidden = !(variant.compare_at_price > variant.price);
      }
      if (saving) {
        var amount = variant.compare_at_price > variant.price ? variant.compare_at_price - variant.price : 0;
        saving.textContent = amount > 0 ? root.getAttribute('data-save-label').replace('[amount]', money(amount)) : '';
        saving.hidden = amount <= 0;
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addText) {
        var addPriceLabel = root.getAttribute('data-add-price-label') || root.getAttribute('data-add-label');
        addText.textContent = variant.available ? addPriceLabel.replace('[price]', money(variant.price)) : root.getAttribute('data-sold-label');
      }
      updateAvailability();
      if (variant.featured_media) activateMedia(variant.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', update); });
    root.querySelectorAll('[data-media-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () { activateMedia(thumb.getAttribute('data-media-target')); });
    });
    update();

    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && addButton && 'IntersectionObserver' in window) {
      var stickyText = sticky.querySelector('[data-sticky-price]');
      sticky.addEventListener('click', function () { addButton.click(); });
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
      }, { threshold: 0 }).observe(addButton);
      optionInputs.forEach(function (input) { input.addEventListener('change', function () { if (stickyText && price) stickyText.textContent = price.textContent; }); });
    }
  }

  function initQuantity() {
    document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          var next = Number(input.value || 1) + (button.hasAttribute('data-quantity-plus') ? 1 : -1);
          input.value = Math.max(Number(input.min || 1), next);
        });
      });
    });
  }

  function initCartQuantity() {
    function updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = count;
        node.style.display = count > 0 ? 'flex' : 'none';
      });
    }
    function changeItem(key, quantity) {
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      }).then(function (cart) {
        updateCount(cart.item_count);
        return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + '?section_id=cart-drawer');
      }).then(function (response) { return response.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-cart-drawer]');
        var current = document.querySelector('[data-cart-drawer]');
        if (next && current) current.innerHTML = next.innerHTML;
      });
    }
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cart-quantity-action]');
      if (!button) return;
      var wrap = button.closest('[data-cart-quantity-wrap]');
      var input = wrap && wrap.querySelector('[data-cart-quantity]');
      if (!input) return;
      var next = Number(input.value || 1) + (button.getAttribute('data-cart-quantity-action') === 'plus' ? 1 : -1);
      input.value = Math.max(0, next);
      changeItem(input.getAttribute('data-key'), Number(input.value));
    });
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;
      changeItem(input.getAttribute('data-key'), Number(input.value || 0));
    });
  }

  function initReviewCarousels() {
    document.querySelectorAll('[data-review-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-review-track]');
      var productHandle = root.getAttribute('data-review-product') || '';
      var limit = Number(root.getAttribute('data-review-limit') || 3);
      if (!track) return;
      var allCards = Array.prototype.slice.call(track.querySelectorAll('[data-review-card]'));
      if (!allCards.length) return;
      var eligible = allCards.filter(function (card) {
        var handles = (card.getAttribute('data-review-handles') || '').split(',').map(function (value) { return value.trim(); }).filter(Boolean);
        return !productHandle || !handles.length || handles.indexOf(productHandle) !== -1;
      });
      if (!eligible.length) eligible = allCards.slice();
      for (var i = eligible.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = eligible[i]; eligible[i] = eligible[j]; eligible[j] = temp;
      }
      allCards.forEach(function (card) { card.hidden = true; });
      eligible.slice(0, limit).forEach(function (card) { card.hidden = false; track.appendChild(card); });

      // Reordering cards can make some browsers preserve the old horizontal
      // anchor at the end of the track. Always begin with the first review.
      track.scrollLeft = 0;
      window.requestAnimationFrame(function () { track.scrollLeft = 0; });

      var previous = root.querySelector('[data-review-prev]');
      var next = root.querySelector('[data-review-next]');
      function moveReviews(direction) {
        var visibleCard = track.querySelector('[data-review-card]:not([hidden])');
        if (!visibleCard) return;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap || 0);
        var step = visibleCard.getBoundingClientRect().width + gap;
        var maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        var target = Math.max(0, Math.min(maximum, track.scrollLeft + (direction * step)));
        track.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });
      }
      if (previous) previous.addEventListener('click', function () { moveReviews(-1); });
      if (next) next.addEventListener('click', function () { moveReviews(1); });
    });
  }

  function initCustomRequestPrefill() {
    var input = document.querySelector('[data-design-preference]');
    if (!input || !window.URLSearchParams) return;
    var handle = new URLSearchParams(window.location.search).get('product');
    if (!handle || input.value) return;
    input.value = window.location.origin + '/products/' + encodeURIComponent(handle);
  }

  function initCollectionFilters() {
    var filters = document.querySelector('[data-collection-filters]');
    var toggle = document.querySelector('[data-filters-toggle]');
    var overlay = document.querySelector('.collection-filters-overlay');
    if (!filters || !toggle) return;

    function setOpen(open) {
      filters.classList.toggle('is-open', open);
      filters.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (overlay) overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('filters-open', open);
      if (open) {
        var closeButton = filters.querySelector('[data-filters-close]');
        if (closeButton) closeButton.focus();
      } else {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setOpen(true);
    });

    filters.querySelectorAll('[data-filters-close]').forEach(function (button) {
      button.addEventListener('click', function () { setOpen(false); });
    });
    if (overlay) overlay.addEventListener('click', function () { setOpen(false); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && filters.classList.contains('is-open')) setOpen(false);
    });
  }

  function initProductAccordions() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-accordion-trigger]');
      if (!trigger) return;
      var item = trigger.closest('[data-accordion]');
      if (!item) return;
      var open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var icon = trigger.querySelector('.product-accordion__icon');
      if (icon) icon.textContent = open ? '−' : '+';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initStickyHeader();
    initReveal();
    initPremiumProduct();
    initQuantity();
    initCartQuantity();
    initReviewCarousels();
    initCustomRequestPrefill();
    initCollectionFilters();
    initProductAccordions();
  });
})();
